import React from 'react';
import { getLanguage } from "../../utility/browser";
import { handlePubhubProjectPreviewRedirection } from "./common";

export default class extends React.Component {

    componentDidMount() {

        const { projectType, projectID, projectStatus } = this.props;
        const config = `https://${CONFIG.PUBHUB_DOMAIN}/app/project/config/${projectID}/${projectStatus}/?${Math.random()}`;
        const site = PubHub.createSitePage({
            container: document.getElementById("devnet-site-preview")
        });

        handlePubhubProjectPreviewRedirection(site, projectID);

        site.defaultLanguage = getLanguage();

        site.on("contentError", () => {
          this.props.onError && this.props.onError('contentError');
        })

        site.on("configDataError", (event) => {
          this.props.onError && this.props.onError('configDataError');
        })

        site.router.baseURL = `/pubhub/${projectType}/${projectID}/${projectStatus}/`;
        site.configURL = config;

        PubHub.env = CONFIG["PUBHUB_ENV"];

        window.site = this.site = site;
    }

    componentWillUpdate(nextProps, nextState) {
        const site = this.site;
        const { projectType, projectID, projectStatus } = nextProps;
        if (site) {
            if (this.props.projectID !== projectID || this.props.projectStatus !== projectStatus) {

                const config = `https://${CONFIG.PUBHUB_DOMAIN}/app/project/config/${projectID}/${projectStatus}/?${Math.random()}`;

                site.clear();

                site.router.baseURL = `/pubhub/${projectType}/${projectID}/${projectStatus}/`;
                site.config = config;
            }
        }
    }

    componentWillUnmount() {
        if (this.site) {
            site.clear();
        }
    }


    render() {
        return (
            <div id="devnet-site-preview"/>
        )
    }
}